import { OfferFormT } from "./types";
import { WarningIcon } from "../../../../../../../shared/infrastructure";
import React, { Fragment } from "react";
import { useFormContext, useWatch } from "react-hook-form";

export const CarrierAlert = (): React.ReactElement => {
  const { control } = useFormContext<OfferFormT>();
  const [carrier] = useWatch({
    control,
    name: ["carrier"],
  });

  return (
    <div className="mt-2 flex w-full justify-start text-[10px]">
      {carrier?.no_dispatch ? (
        <span className="rounded-[5px] bg-red-500 px-3 py-1 font-medium text-white">
          (DNU)
        </span>
      ) : carrier && carrier.status === "I" ? (
        <div className="grid grid-flow-col items-center justify-center gap-[8px] rounded-[5px] bg-[#FFBD2E] px-2 py-1 text-white">
          <WarningIcon />
          <span className="font-medium">Inactive Carrier</span>
        </div>
      ) : carrier?.status === "N" ? (
        <span className="rounded-[5px] bg-[#3C7CF3] px-2 py-1 font-medium text-white">
          (New Carrier)
        </span>
      ) : (
        <Fragment />
      )}
    </div>
  );
};
